import { getDatePeriod } from '@/helpers/dateHelper';
import { useMemo } from 'react';

export type RosterPeriodOption = 'week' | 'month';

export const useRosterPeriodDates = (option: RosterPeriodOption): Date[] => {
  const weekStartsOn = 1;

  const { startDate, endDate } = useMemo(() => {
    let startDate: Date;
    let endDate: Date;

    switch (option) {
      case 'week':
        startDate = new Date();
        while (startDate.getUTCDay() !== weekStartsOn) {
          startDate.setUTCDate(startDate.getUTCDate() + 1);
        }

        endDate = new Date(startDate);
        endDate.setUTCDate(endDate.getUTCDate() + 6);
        break;
      case 'month':
        startDate = new Date();
        startDate.setUTCDate(1);
        startDate.setUTCMonth(startDate.getUTCMonth() + 1);
        endDate = new Date(startDate);
        endDate.setUTCMonth(endDate.getUTCMonth() + 1);
        endDate.setUTCDate(0);

        break;
    }
    return { startDate, endDate };
  }, [option]);

  const rosterPeriod = useMemo(() => {
    return getDatePeriod(startDate, endDate);
  }, [startDate, endDate]);

  return rosterPeriod;
};
